module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "max-width"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    class: {
      disabled: _vm.loading
    }
  }, [_c('h1', [_vm._v("GDPR-rensa")]), _vm._v(" "), _c('label', [_vm._v("Välj datum att rensa från")]), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "validated": false,
      "label": '' + _vm.formatDate(_vm.pickedStartDate) + '',
      "bold-label": false
    },
    on: {
      "clicked": _vm.datepickerRangeModal,
      "clicked-suffix": _vm.dateClear
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.clean
    }
  }, [_vm._v("Rensa online-registret innan " + _vm._s(_vm.formatDate(_vm.pickedStartDate)))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20734156"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/GdprCleanup.vue
// module id = 916
// module chunks = 0